// @flow

import React from 'react';
import { SingleDatePicker } from 'react-dates';

// $FlowFixMe
import 'react-dates/lib/css/_datepicker.css';
import { injectGlobal } from 'styled-components';
import { colors, fontWeight } from 'seedling/constants';
import { filterObjectProperties } from 'seedling/utils/object_utils';

type Props = {
  focusOnMount: boolean,
  onFocusChange: boolean => void,
  enableOutsideDays: boolean,
  isOutsideRange: () => boolean,
  numberOfMonths: number,
  placeholder: string,
  id: string,
  displayFormat: string,
};

type State = {
  focused: boolean,
};

export default class DatePicker extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      focused: props.focusOnMount,
    };
  }

  static defaultProps = {
    focusOnMount: false,
    onFocusChange: () => {},
    enableOutsideDays: true,
    isOutsideRange: () => false,
    numberOfMonths: 1,
    placeholder: 'Date',
    id: 'date',
    displayFormat: 'MM/DD/YYYY',
  };

  onFocusChange = (focused: boolean) => {
    this.setState({ focused }, () => {
      this.props.onFocusChange(focused);
    });
  };

  render() {
    // we want to be able to pass props to our Datepicker wrapper component
    // without them being passed automatically to the underlying SingleDatePicker
    // component, so we filter only allowed props.
    const allowedPropTypes = Object.keys(SingleDatePicker.propTypes);
    const allowedProps = filterObjectProperties(this.props, allowedPropTypes);

    return (
      <SingleDatePicker
        {...allowedProps}
        focused={this.state.focused}
        onFocusChange={({ focused }) => this.onFocusChange(focused)}
      />
    );
  }
}

export const injectGlobalCalendarStyles = (
  calendarClassname: string,
  additionalStyles: ?string
) => {
  injectGlobal`
    .${calendarClassname} {
      .${calendarClassname}Input {
        border: none;
      }

      .DateInput {
        font-size: 14px;
        padding: 5px 6px;

      }

      .DateInput__display-text.DateInput__display-text--has-input {
        color: ${colors.darkestGrey};
      }

      .CalendarDay--selected {
        .CalendarDay__button:focus {
          background: ${colors.lightBlue};
        }
      }

      .DateInput__display-text {
        padding: 0px 5px;
        font-weight: ${fontWeight.normal};
        color: ${colors.darkGrey};
      }
      .DateInput__display-text--focused {
        background: none;
        border-color: none;
      }
      .CalendarDay {
        ${fontWeight('normal')}
      }
      .CalendarDay--hovered {
        background: ${colors.lighterGrey};
      }
      .CalendarDay--selected {
        background: ${colors.lightBlue};
      }
      .CalendarDay--highlighted-calendar {
        background: ${colors.lightestGrey};
      }
      .CalendarDay--today {
        background: auto;
      }
      .CalendarDay--selected-start,
      .CalendarDay--selected-end,
      .CalendarDay--selected {
        border: none;
        color: inherit;
      }
      .DayPickerKeyboardShortcuts__show--bottom-right {
        display: none;
      }
      .DayPicker__week-header {
        top: 55px;
        ${fontWeight('normal')}
      }

      .DayPickerNavigation--horizontal .DayPickerNavigation__prev:hover,
      .DayPickerNavigation--horizontal .DayPickerNavigation__next:hover {
        background: ${colors.lightestGrey};
      }

      .DayPickerNavigation--horizontal .DayPickerNavigation__prev:focus,
      .DayPickerNavigation--horizontal .DayPickerNavigation__next:focus {
        outline: none;
      }

      .DateInput {
        border: 1px solid ${colors.lightGrey};
        border-radius: 2px;
      }

      .DateInput--with-caret {
        border: 1px solid ${colors.mediumGreenhouseGreen};
      }

      /* Moving the calendar closer to the date input */
      .DateInput--with-caret::before {
        top: 40px;
      }
      .DateInput--with-caret::after {
        top: 41px;
      }
      .${calendarClassname}__picker {
        z-index: 5;
        top: 50px;
      }
      ${additionalStyles}
    }
  `;
};

injectGlobalCalendarStyles('SingleDatePicker');
